document.addEventListener('DOMContentLoaded', () => {
    // Smooth scroll for CTA button and any other anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            e.preventDefault();
            const targetId = this.getAttribute('href');
            const targetElement = document.querySelector(targetId);
            
            if (targetElement) {
                // Smooth scroll to target element
                targetElement.scrollIntoView({ 
                    behavior: 'smooth',
                    block: 'start'
                });
                
                // Add a highlight effect to the target element
                targetElement.classList.add('highlight-section');
                setTimeout(() => {
                    targetElement.classList.remove('highlight-section');
                }, 2000);
            }
        });
    });

    // Use the current host when running locally instead of hardcoded URL
    const API_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname === '192.168.1.135' 
        ? '' // Empty string will use the current host
        : 'https://cny-app-2025.vercel.app';
    const messagesContainer = document.getElementById('messages-container');
    const submitForm = document.getElementById('submit-form');
    const errorMessage = document.getElementById('error-message');
    const successMessage = document.getElementById('success-message');
    const loadingSpinner = document.getElementById('loading-spinner');
    const successModal = document.getElementById('successModal');
    const messageModal = document.getElementById('messageModal');
    const successModalCloseButton = successModal.querySelector('.modal-close');
    const messageModalCloseButton = messageModal.querySelector('.modal-close');

    let cachedMessages = [];
    let isFirstLoad = true;
    let newMessageAdded = false;
    let autoScrollInterval;

    // Modal handling
    successModalCloseButton.addEventListener('click', () => {
        // First hide the modal
        successModal.style.display = 'none';
        
        // Always scroll to messages when closing the success modal, regardless of newMessageAdded flag
        const messagesContainerWrapper = document.querySelector('.messages-container-wrapper');
        
        // Small delay to ensure modal is hidden first
        setTimeout(() => {
            // Reset horizontal scroll position
            messagesContainer.scrollLeft = 0;
            
            // Scroll to messages section with window.scrollTo for more reliable scrolling
            window.scrollTo({
                top: messagesContainerWrapper.offsetTop - 20, // Offset by 20px to give some space
                behavior: 'smooth'
            });
            
            // Highlight the messages container briefly
            messagesContainerWrapper.classList.add('highlight-section');
            setTimeout(() => {
                messagesContainerWrapper.classList.remove('highlight-section');
            }, 2000);
            
            // If there was a new message, refresh display
            if (newMessageAdded) {
                displayMessages();
                newMessageAdded = false;
            }
        }, 100); // Small delay for better UX
    });

    messageModalCloseButton.addEventListener('click', () => {
        messageModal.style.display = 'none';
        resumeAutoScroll();
    });

    // Close modals when clicking outside
    window.addEventListener('click', (e) => {
        if (e.target === messageModal) {
            messageModal.style.display = 'none';
            resumeAutoScroll();
        }
        if (e.target === successModal) {
            // First hide the modal
            successModal.style.display = 'none';
            
            // Always scroll to messages when closing the success modal, regardless of newMessageAdded flag
            const messagesContainerWrapper = document.querySelector('.messages-container-wrapper');
            
            // Small delay to ensure modal is hidden first
            setTimeout(() => {
                // Reset horizontal scroll position
                messagesContainer.scrollLeft = 0;
                
                // Scroll to messages section with window.scrollTo for more reliable scrolling
                window.scrollTo({
                    top: messagesContainerWrapper.offsetTop - 20, // Offset by 20px to give some space
                    behavior: 'smooth'
                });
                
                // Highlight the messages container briefly
                messagesContainerWrapper.classList.add('highlight-section');
                setTimeout(() => {
                    messagesContainerWrapper.classList.remove('highlight-section');
                }, 2000);
                
                // If there was a new message, refresh display
                if (newMessageAdded) {
                    displayMessages();
                    newMessageAdded = false;
                }
            }, 100); // Small delay for better UX
        }
    });

    function showMessageDetail(msg) {
        pauseAutoScroll();

        const messageAuthor = messageModal.querySelector('.message-author');
        const messageTime = messageModal.querySelector('.message-time');
        const messageContent = messageModal.querySelector('.message-full-content');
        const emotionIconContainer = messageModal.querySelector('.message-emotion-icon');
        const modalContent = messageModal.querySelector('.modal-content');
        
        // Reset any previous custom styles
        modalContent.style.backgroundColor = '';
        modalContent.style.borderLeft = '';

        messageAuthor.textContent = msg.name || '毛孩家長';
        
        const date = new Date(msg.timestamp || msg.date);
        const formattedDate = new Intl.DateTimeFormat('zh-HK', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        }).format(date);
        
        messageTime.textContent = formattedDate;
        messageContent.textContent = msg.message;
        
        // Clear previous emotion icon if any
        emotionIconContainer.innerHTML = '';
        
        // Add emotion icon if message has a type and set matching background
        if (msg.type) {
            let iconSrc = null;
            let backgroundColor = null;
            let borderColor = null;
            
            switch(msg.type) {
                case 'angry':
                    iconSrc = 'https://cdn.shopify.com/s/files/1/0607/6494/6632/files/cuteicon-angry.png?v=1754973758';
                    backgroundColor = '#FF5A5A';
                    borderColor = '#D10000';
                    break;
                case 'fear':
                    iconSrc = 'https://cdn.shopify.com/s/files/1/0607/6494/6632/files/cuteicon-fear.png?v=1754973758';
                    backgroundColor = '#c768d8';
                    borderColor = '#5e1c69';
                    break;
                case 'sad':
                    iconSrc = 'https://cdn.shopify.com/s/files/1/0607/6494/6632/files/cuteicon-sad.png?v=1754973758';
                    backgroundColor = '#64B5F6';
                    borderColor = '#1976D2';
                    break;
                case 'happy':
                    backgroundColor = '#FFC107';
                    borderColor = '#FF8F00';
                    break;
                case 'calm':
                    backgroundColor = 'var(--primary-color)';
                    borderColor = '#2A1B47';
                    break;
                default:
                    backgroundColor = 'var(--secondary-color)';
                    borderColor = '#A38D69';
            }
            
            // Apply the background and border colors to match message card
            if (backgroundColor) {
                modalContent.style.backgroundColor = backgroundColor;
                modalContent.style.borderLeft = `8px solid ${borderColor}`;
            }
            
            if (iconSrc) {
                const emotionIcon = document.createElement('img');
                emotionIcon.src = iconSrc;
                emotionIcon.className = 'detail-emotion-icon';
                emotionIcon.alt = msg.type;
                emotionIconContainer.appendChild(emotionIcon);
            }
        }

        messageModal.style.display = 'flex';
    }

    function pauseAutoScroll() {
        if (window.messageScroll) {
            window.messageScroll.stop();
        }
    }

    function resumeAutoScroll() {
        if (window.messageScroll && messageModal.style.display !== 'flex') {
            window.messageScroll.start();
        }
    }

    // Progress bar functionality has been removed

    async function loadMessages() {
        try {
            loadingSpinner.style.display = 'flex';
            
            // Clear cached messages before fetching new ones
            cachedMessages = [];
    
            const response = await fetch(`${API_URL}/api/messages`);
            if (!response.ok) {
                throw new Error('Failed to load messages');
            }
            
            const data = await response.json();
            
            if (!Array.isArray(data.messages)) {
                throw new Error('Invalid message format');
            }
    
            // Update cached messages with the latest messages
            cachedMessages = data.messages.sort((a, b) => {
                const dateA = new Date(b.updatedAt || b.date);
                const dateB = new Date(a.updatedAt || a.date);
                return dateA - dateB;
            });
    
            // Only duplicate messages if we have less than minimum required
            const minRequired = 20;
            if (cachedMessages.length < minRequired) {
                while (cachedMessages.length < minRequired) {
                    const messagesToAdd = [...cachedMessages];
                    cachedMessages.push(...messagesToAdd);
                }
            }
    
            displayMessages();
            // Progress bar update removed
            isFirstLoad = false;
            
            // Start scrolling after messages are loaded
            if (window.messageScroll && window.messageScroll.start) {
                window.messageScroll.start();
            }
    
        } catch (error) {
            console.error('Error loading messages:', error);
            messagesContainer.innerHTML = '<div class="loading-error">載入失敗，請稍後再試</div>';
        } finally {
            loadingSpinner.style.display = 'none';
        }
    }

    function displayMessages() {
        if (!messagesContainer) return;
        messagesContainer.innerHTML = '';

        if (!Array.isArray(cachedMessages) || cachedMessages.length === 0) {
            messagesContainer.innerHTML = '<div class="loading-error">暫無留言</div>';
            return;
        }

        // The first 5 messages are the latest ones
        const latestMessages = cachedMessages.slice(0, 5);
        const remainingMessages = cachedMessages.slice(5);

        // Display all messages
        [...latestMessages, ...remainingMessages].forEach((msg, index) => {
            if (!msg) return;
            
            const messageCard = document.createElement('div');
            // Use type field if available, otherwise use random color class
            const typeClass = msg.type ? `message-type-${msg.type}` : `message-color-${Math.floor(Math.random() * 4) + 1}`;
            messageCard.className = `message-card ${typeClass}`;
            
            // Add emotion type icon if applicable
            if (msg.type) {
                let showIcon = true;
                const emotionIcon = document.createElement('img');
                emotionIcon.className = 'emotion-icon';
                
                // Map emotion types to their respective icon images
                switch(msg.type) {
                    case 'angry':
                        emotionIcon.src = 'https://cdn.shopify.com/s/files/1/0607/6494/6632/files/cuteicon-angry.png?v=1754973758';
                        emotionIcon.alt = 'Angry';
                        break;
                    case 'fear': // Treating worried as fear
                        emotionIcon.src = 'https://cdn.shopify.com/s/files/1/0607/6494/6632/files/cuteicon-fear.png?v=1754973758';
                        emotionIcon.alt = 'Worried';
                        break;
                    case 'sad':
                        emotionIcon.src = 'https://cdn.shopify.com/s/files/1/0607/6494/6632/files/cuteicon-sad.png?v=1754973758';
                        emotionIcon.alt = 'Sad';
                        break;
                    default:
                        showIcon = false; // No icon for other emotions
                }
                
                if (showIcon) {
                    messageCard.appendChild(emotionIcon);
                }
            }
            
            const content = document.createElement('div');
            content.className = 'message-content';
            content.textContent = msg.message || '';
            messageCard.appendChild(content);

            const name = document.createElement('div');
            name.className = 'message-name';
            name.textContent = msg.name || '毛孩家長';
            messageCard.appendChild(name);

            const formattedDate = new Intl.DateTimeFormat('zh-HK', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            }).format(new Date(msg.timestamp || msg.date || Date.now()));

            const date = document.createElement('div');
            date.className = 'message-date';
            date.textContent = formattedDate;
            messageCard.appendChild(date);

            messageCard.onclick = () => {
                const msgCopy = {...msg};
                showMessageDetail(msgCopy);
            };
            
            messagesContainer.appendChild(messageCard);
        });

        if (window.messageScroll && window.messageScroll.start) {
            window.messageScroll.start();
        }
    }

    submitForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        
        // Clear previous error messages
        errorMessage.style.display = 'none';
        errorMessage.textContent = '';
        
        const email = submitForm.querySelector('#email').value.trim();
        const name = submitForm.querySelector('#name').value.trim();
        const message = submitForm.querySelector('#message').value.trim();
        const selectedRadio = submitForm.querySelector('input[name="type"]:checked');
        const type = selectedRadio ? selectedRadio.value : 'default';

        if (!email || !message) {
            errorMessage.textContent = '請填寫所有必填欄位';
            errorMessage.style.display = 'flex';
            return;
        }

        if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
            errorMessage.textContent = '請輸入有效的電郵地址';
            errorMessage.style.display = 'flex';
            return;
        }
        
        // Validate that user has selected a specific emotion type
        if (!selectedRadio) {
            errorMessage.textContent = '請選擇狗狗的情緒狀態';
            errorMessage.style.display = 'flex';
            return;
        }

        errorMessage.textContent = '';
        const submitButton = submitForm.querySelector('button');
        submitButton.disabled = true;
        submitButton.textContent = '發送中...';
        loadingSpinner.style.display = 'flex';

        try {
            if (email !== 'msncyp@gmail.com') {
                const checkResponse = await fetch(`${API_URL}/api/check-email`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ email })
                });

                const checkData = await checkResponse.json();
                
                if (!checkResponse.ok) {
                    throw new Error(checkData.error || checkData.details || '檢查電郵時發生錯誤');
                }

                if (!checkData.canSubmit) {
                    throw new Error('此電郵已經提交過資料，每個電郵只能提交一次。');
                }
            }

            const response = await fetch(`${API_URL}/api/submit`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email,
                    name,
                    message,
                    type
                })
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || data.details || '提交失敗');
            }

            // Ensure we have valid data structure
            if (!data || !data.data) {
                throw new Error('伺服器回應格式錯誤');
            }

            const timestamp = new Date().toISOString();
            const newMessage = {
                id: (data.data && data.data.id) || Date.now().toString(),
                name: name || '毛孩家長',
                message: message || '',
                timestamp: timestamp,
                date: timestamp,
                type: type, // Add the emotion type to the message object
                isNew: true
            };

            if (!Array.isArray(cachedMessages)) {
                cachedMessages = [];
            }

            const visibleCards = Array.from(messagesContainer?.children || []);
            const centerIndex = Math.floor(visibleCards.length / 2);
            
            cachedMessages.splice(centerIndex, 0, newMessage);
            
            const messageCard = document.createElement('div');
            // Use type field if available, otherwise use random color class
            const typeClass = type ? `message-type-${type}` : `message-color-${Math.floor(Math.random() * 4) + 1}`;
            messageCard.className = `message-card ${typeClass} new-message`;
            messageCard.dataset.index = centerIndex.toString();

            // Add emotion type icon if applicable
            if (type) {
                let showIcon = true;
                const emotionIcon = document.createElement('img');
                emotionIcon.className = 'emotion-icon';
                
                // Map emotion types to their respective icon images
                switch(type) {
                    case 'angry':
                        emotionIcon.src = 'https://cdn.shopify.com/s/files/1/0607/6494/6632/files/cuteicon-angry.png?v=1754973758';
                        emotionIcon.alt = 'Angry';
                        break;
                    case 'fear':
                        emotionIcon.src = 'https://cdn.shopify.com/s/files/1/0607/6494/6632/files/cuteicon-fear.png?v=1754973758';
                        emotionIcon.alt = 'Worried';
                        break;
                    case 'sad':
                        emotionIcon.src = 'https://cdn.shopify.com/s/files/1/0607/6494/6632/files/cuteicon-sad.png?v=1754973758';
                        emotionIcon.alt = 'Sad';
                        break;
                    default:
                        showIcon = false; // No icon for other emotions
                }
                
                if (showIcon) {
                    messageCard.appendChild(emotionIcon);
                }
            }

            const badge = document.createElement('div');
            badge.className = 'new-badge';
            badge.textContent = '新';
            messageCard.appendChild(badge);

            const content = document.createElement('div');
            content.className = 'message-content';
            content.textContent = newMessage.message;
            messageCard.appendChild(content);

            const nameElement = document.createElement('div');
            nameElement.className = 'message-name';
            nameElement.textContent = newMessage.name;
            messageCard.appendChild(nameElement);

            const formattedDate = new Intl.DateTimeFormat('zh-HK', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            }).format(new Date(timestamp));

            const date = document.createElement('div');
            date.className = 'message-date';
            date.textContent = formattedDate;
            messageCard.appendChild(date);

            messageCard.onclick = () => {
                const msg = {...newMessage};
                showMessageDetail(msg);
            };

            if (visibleCards[centerIndex]) {
                messagesContainer.insertBefore(messageCard, visibleCards[centerIndex]);
            } else {
                messagesContainer.appendChild(messageCard);
            }

            const cardWidth = messageCard.offsetWidth;
            const containerWidth = messagesContainer.offsetWidth;
            const scrollPosition = (centerIndex * cardWidth) - (containerWidth / 2) + (cardWidth / 2);
            
            pauseAutoScroll();
            messagesContainer.scrollTo({
                left: scrollPosition,
                behavior: 'smooth'
            });
            
            successModal.style.display = 'flex';
            submitForm.reset();

            setTimeout(resumeAutoScroll, 1000);

        } catch (error) {
            console.error('Submission error:', error);
            errorMessage.textContent = error.message === 'Email not found in customer list' 
                ? '此電郵不在我們的顧客名單中，請立即註冊成為會員。'
                : error.message;
            errorMessage.style.display = 'flex';
        } finally {
            submitButton.disabled = false;
            submitButton.textContent = '送出';
            loadingSpinner.style.display = 'none';
        }
    });

    function initializeMessageScroll() {
        const container = messagesContainer;
        let isScrolling = true;
        let scrollSpeed = 1;
        const scrollStep = 50;
        let lastTouchX = 0;
        let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        let userInitiatedScroll = false;
        let isVisible = false;
        let scrollTimeout;

        function scrollMessages() {
            if (!isScrolling || userInitiatedScroll) return;

            const scrollLeft = container.scrollLeft;
            const maxScroll = container.scrollWidth - container.offsetWidth;

            if (scrollLeft >= maxScroll) {
                container.scrollTo({
                    left: 0,
                    behavior: 'instant'
                });
            } else {
                container.scrollLeft += scrollSpeed;
            }

            // Clear existing timeout
            if (scrollTimeout) {
                clearTimeout(scrollTimeout);
            }

            // Schedule next scroll
            scrollTimeout = setTimeout(() => {
                requestAnimationFrame(scrollMessages);
            }, scrollStep);
        }

        // Start auto-scroll
        function startAutoScroll() {
            isScrolling = true;
            userInitiatedScroll = false;
            scrollMessages();
        }

        // Stop auto-scroll
        function stopAutoScroll() {
            isScrolling = false;
            if (scrollTimeout) {
                clearTimeout(scrollTimeout);
            }
        }

        // Touch event handlers
        container.addEventListener('touchstart', (e) => {
            stopAutoScroll();
            lastTouchX = e.touches[0].clientX;
        }, { passive: true });

        container.addEventListener('touchmove', (e) => {
            userInitiatedScroll = true;
        }, { passive: true });

        container.addEventListener('touchend', () => {
            // Wait a bit before restarting auto-scroll
            setTimeout(() => {
                userInitiatedScroll = false;
                startAutoScroll();
            }, 1000);
        });

        // Mouse event handlers (desktop only)
        if (!isMobile) {
            container.addEventListener('mouseenter', stopAutoScroll);
            container.addEventListener('mouseleave', startAutoScroll);
        }

        // Visibility change handler
        document.addEventListener('visibilitychange', () => {
            if (document.hidden) {
                stopAutoScroll();
            } else {
                startAutoScroll();
            }
        });

        // Intersection Observer
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    startAutoScroll();
                } else {
                    stopAutoScroll();
                }
            });
        }, { threshold: 0.1 });

        observer.observe(container);

        // Export scroll controls
        window.messageScroll = {
            start: startAutoScroll,
            stop: stopAutoScroll
        };

        // Initial start if visible
        if (container.getBoundingClientRect().top < window.innerHeight) {
            startAutoScroll();
        }

        // Add scroll overlay handlers
        const scrollLeft = document.querySelector('.scroll-left');
        const scrollRight = document.querySelector('.scroll-right');
        
        scrollLeft.addEventListener('click', () => {
            stopAutoScroll();
            const scrollAmount = container.offsetWidth * 0.8;
            container.scrollBy({
                left: -scrollAmount,
                behavior: 'smooth'
            });
            setTimeout(startAutoScroll, 1000);
        });

        scrollRight.addEventListener('click', () => {
            stopAutoScroll();
            const scrollAmount = container.offsetWidth * 0.8;
            container.scrollBy({
                left: scrollAmount,
                behavior: 'smooth'
            });
            setTimeout(startAutoScroll, 1000);
        });

        // Show/hide overlays based on scroll position
        container.addEventListener('scroll', () => {
            const isAtStart = container.scrollLeft <= 0;
            const isAtEnd = container.scrollLeft >= container.scrollWidth - container.offsetWidth;
            
            scrollLeft.style.opacity = isAtStart ? '0.3' : '1';
            scrollRight.style.opacity = isAtEnd ? '0.3' : '1';
            
            scrollLeft.style.pointerEvents = isAtStart ? 'none' : 'auto';
            scrollRight.style.pointerEvents = isAtEnd ? 'none' : 'auto';
        });
    }

    resumeAutoScroll();
    loadMessages();
    initializeMessageScroll();
    
    // Handle emotion box selection
    const emotionBoxes = document.querySelectorAll('.emotion-box');
    emotionBoxes.forEach(box => {
        box.addEventListener('click', function() {
            // Find the radio input inside this box and check it
            const radioInput = this.querySelector('input[type="radio"]');
            radioInput.checked = true;
            
            // Remove selected class from all boxes and add to the clicked one
            emotionBoxes.forEach(b => b.classList.remove('selected-box'));
            this.classList.add('selected-box');
        });
    });
});